import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 radius-7 bg-white expected-earnings-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis" }, " DATA ", -1)
const _hoisted_4 = { class: "fw-black mb-12 lh-1" }
const _hoisted_5 = { class: "list ps-0 mb-0 list-unstyled mt-15" }
const _hoisted_6 = { class: "text-muted position-relative fw-medium" }
const _hoisted_7 = { class: "text-black fw-bold" }
const _hoisted_8 = { class: "text-muted position-relative fw-medium" }
const _hoisted_9 = { class: "text-black fw-bold" }
const _hoisted_10 = { class: "text-muted position-relative fw-medium" }
const _hoisted_11 = { class: "text-black fw-bold" }
const _hoisted_12 = { class: "text-muted position-relative fw-medium" }
const _hoisted_13 = { class: "text-black fw-bold" }
const _hoisted_14 = { class: "text-muted position-relative fw-medium" }
const _hoisted_15 = { class: "text-black fw-bold" }
const _hoisted_16 = { class: "mt-4 fw-bold text-success text-badge d-inline-block" }
const _hoisted_17 = {
  id: "expectedEraningsChart",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", null, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.getMetricsToday.formatted_date), 1),
        _createElementVNode("ul", _hoisted_5, [
          _createElementVNode("li", _hoisted_6, [
            _createTextVNode(" Dia da semana: "),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.getMetricsToday.day_of_week_name), 1)
          ]),
          _createElementVNode("li", _hoisted_8, [
            _createTextVNode(" Semana do ano: "),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getMetricsToday.week_of_year), 1)
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createTextVNode(" Dia do ano: "),
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getMetricsToday.day_of_year), 1)
          ]),
          _createElementVNode("li", _hoisted_12, [
            _createTextVNode(" Trimestre: "),
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getMetricsToday.quarter), 1)
          ]),
          _createElementVNode("li", _hoisted_14, [
            _createTextVNode(" Semestre: "),
            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getMetricsToday.semester), 1)
          ])
        ]),
        _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.getMetricsToday.compared_to_yesterday) + "% ", 1),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_apexchart, {
            type: "donut",
            height: "150",
            options: _ctx.expectedEraningsChart,
            series: [_ctx.getMetricsToday.total_success, _ctx.getMetricsToday.total_error]
          }, null, 8, ["options", "series"])
        ])
      ])
    ])
  ]))
}